/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Contents } from "../models";
import { SortDirection } from "@aws-amplify/datastore";
import {
  createDataStorePredicate,
  getOverrideProps,
  useDataStoreBinding,
} from "@aws-amplify/ui-react/internal";
import ProductCard2 from "./ProductCard2_fix";
import { Collection } from "@aws-amplify/ui-react";
export default function ProductCard2Collection_bk(props) {
  const { items: itemsProp, overrideItems, overrides,operand,operand2, ...rest } = props;
  
// const itemsFilterObj = operand
//   ? { field: "UserID", operand, operator: "eq" } // operand の値がある場合
//   : { field: "UserID", operand, operator: "ne" }; // operand の値がない場合
// const itemsFilter = createDataStorePredicate(itemsFilterObj);
  
let itemsFilter = null;

if (operand) {
  // operand が指定された場合、等しい条件でフィルタリング
  itemsFilter = createDataStorePredicate({
    field: "UserID",
    operand,
    operator: "eq",
  });
} else if (operand2) {
  // operand2 が指定された場合、異なる条件でフィルタリング
  itemsFilter = createDataStorePredicate({
    field: "UserID",
    operand: operand2,
    operator: "ne",
  });
}
  
  
  const itemsPagination = { sort: (s) => s.Title(SortDirection.ASCENDING) };

  
  const [items, setItems] = React.useState(undefined);
  const itemsDataStore = useDataStoreBinding({
    type: "collection",
    model: Contents,
    criteria: itemsFilter,
    pagination: itemsPagination,
  }).items;
  
  React.useEffect(() => {
    if (itemsProp !== undefined) {
      setItems(itemsProp);
      return;
    }
    async function setItemsFromDataStore() {
      var loaded = await Promise.all(
        itemsDataStore.map(async (item) => ({
          ...item,
          ContentsComment: await item.ContentsComment.toArray(),
        }))
      );
      setItems(loaded);
    }
    setItemsFromDataStore();
  }, [itemsProp, itemsDataStore]);
  return (
     <Collection
      type="list"
      isPaginated={true}
      direction="column"
      alignItems="stretch"
      justifyContent="center"
      gap="1px"
      wrap="wrap"
      backgroundColor="#808080"
      items={items || []}
      {...getOverrideProps(overrides, "ProductCard2Collection")}
      {...rest}
    >
      {(item, index) => (
        <ProductCard2
        　onClick={ () => location.href = `/DetailAreaNew?article_id=${item.id}` }
          contents={item}
          key={item.id}
          {...(overrideItems && overrideItems({ item, index }))}
        ></ProductCard2>
      )}
    </Collection>
  );
}
